import { selfAxios } from "../../../../axios/selfAxios.js";
async function reqGetBelongOrderClassify(params) {
  const { data } = await selfAxios.get("/designapi/design/getBelongOrderClassify", { params, _cache: true });
  return data.data;
}
export { reqGetBelongOrderClassify };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/getBelongOrderClassify/get.js